// What a host hands the access views (ADR 0060): the SDK's client for the app the page is about. The views never
// import a host and never name an address.
import type { AccessClient } from '@cortex/sdk-access-client';
import * as React from 'react';

export interface AccessHost {
  /** The SDK's client, at where the host mounts the access routes of the app open. */
  client: AccessClient;
  /** Names the app the client reaches (what the views reload on when it changes). */
  scope: string;
}

const Ctx = React.createContext<AccessHost | null>(null);

export function AccessHostProvider({ host, children }: { host: AccessHost; children: React.ReactNode }) {
  return <Ctx.Provider value={host}>{children}</Ctx.Provider>;
}

export function useAccessHost(): AccessHost {
  const h = React.useContext(Ctx);
  if (!h) throw new Error('The access views need an <AccessHostProvider> (the host’s client)');
  return h;
}

/** The message of a failed call: the API's own sentence, else its status. */
export function errorMessage(error: unknown, response?: Response): string {
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string')
    return error.message;
  return response ? `The API answered ${response.status}.` : 'The API is unreachable.';
}
